$(document).ready(function () {
  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1500,
    slidesToShow: 1,    
    adaptiveHeight: true,
  });

  $(".icons-slider").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $('.marquee-left').marquee({
    direction: 'left',
    duration: 30000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });
  
});